<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/activity' }">双创活动</el-breadcrumb-item>
						<el-breadcrumb-item >订单详情</el-breadcrumb-item>
					</el-breadcrumb>
					
					<el-row  class="page save">
						<template >
							<el-col :span="20" class="table">
								<div class="lists">
									<template>
										<div class="list">
											<el-row class="name" style="margin-bottom: 10px;">
												<el-col :span="12">
													订单号：{{payInfo.orderno?payInfo.orderno:''}}
												</el-col>
												<el-col :span="12" style="color: #D2D2D2;">
													{{payInfo.createDate?payInfo.createDate:''}}
												</el-col>
											</el-row>
											<el-row  style="display: flex;align-items: center;font-size: 16px;">
												<template v-if="payInfo.product">
													<el-col :span="3" >
														<img :src="payInfo.product.image?imgPath(payInfo.product.image) : require('../../static/p.jpg')" />
													</el-col>
													<el-col :span="10">
														<p>{{payInfo.product.name?payInfo.product.name:''}}</p>
														<p>购买数量 x {{payInfo.counts?payInfo.counts:''}}</p>
														<p>付款金额： {{payInfo.sum?payInfo.sum:''}}</p>
													</el-col>
												</template>
												<template v-if="payInfo.activity">					
													<el-col :span="10">
														<p>{{payInfo.activity.actTitle?payInfo.activity.actTitle:''}}</p>
													</el-col>
												</template>
												<el-col :span="10">
													<el-button type="primary">{{msg}}</el-button>
												</el-col>
											</el-row>
										</div>
									</template>
								</div>
							</el-col>
						</template>
					</el-row>	
					</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import {activityOrderDetail} from '@/api';

export default {
  name: 'activityOrderDetail',
  components:{
	sHeader,
	sFooter,
	sCopyRight
  },
  data () {
    return {
		token:'',
		msg:'',
		payInfo:null 
    }
  },
  mounted() {
	  console.log('id',this.$route.query.id)
	activityOrderDetail({
		orderNO:this.$route.query.id
	}).then(res=> {
		this.payInfo=res.data
		this.msg=res.msg
	})
  },
  methods:{
	  //图片地址
	  imgPath(oldPath){			
	  	return this.$imgBaseUrl + oldPath
	  },
  }
}
</script>

<style lang="scss" scoped>

.page{	
	min-height: 524px; /*若没有tabs56  height524 若有height468 */
}

.detail_info_image{
	text-align: center;
}
.detail_info_mark{
	// height: 160px;
}
.name{	
	font-size: 14px;
	padding-top: 10px;
	font-weight: 600;
}

.el-menu.el-menu--horizontal {
    border-bottom: none;
}
/*我的收藏*/
.save{
	.type .el-radio-group{
		display: flex;
		flex-direction: column;	
	}
	.type .el-radio{
		margin-left: 0 !important;
		margin-right: 0 !important;
		margin-bottom: 10px;
	}
	.table{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
	}
	.lists{
		width: 100%;
	}
	.list{
		// border-bottom: 1px solid #C0C4CC;
			img{
				width: 100px;
				height: 100px;
			}
			p{
				line-height: 30px;
			}
	}
	.name{	
		font-size: 14px;
		padding-top: 10px;
	}
	.label{	
		/* width: 98px; */
		height: 20px;
		color: rgba(153, 153, 153, 1);
		font-size: 14px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.label span{
		margin-right: 20px;
	}
	
}
/*我的订单*/
.order{
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;
	
	.lists{
		width: 100%; 
		display: flex;
		flex-direction: row;
		flex-wrap:wrap;
	}
	.list{
		/* height: 320px; */
		width: 250px;
		border: 1px solid #CCCCCC;
		margin-left: 15px;
		margin-right: 15px;
		margin-bottom: 30px;
		position: relative;
	}
	
	.img{
		height: 180px;
		padding: 10px;
		width: 100%;
	}
	
	.info{
		margin-left: 10px;
		margin-right: 10px;
	}
		
	.name{
		height: 26px;
		line-height: 26px;
	}
	.price{
		line-height: 30px;
		height: 30px;
		color: #EE3438;
	}
	.time{
		line-height: 26px;
		color: rgba(153, 153, 153, 1);
	}
}
/*反馈*/
.guest{
	.table{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
	}
	.lists{
		width: 100%;
	}
	.list{
		border-bottom: 1px solid #C0C4CC;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
}

</style>



// WEBPACK FOOTER //
// src/views/activity-order-detail.vue